import { FC, useState } from 'react';
import cx from 'classnames';
import { useQueryClient } from '@tanstack/react-query';
// type
import { LinkCopiedSuccessfully } from 'core/constants';
import { IOpportunityResponse, OPPORTUNITY_ACTIVE_STATUS, OPPORTUNITY_STATUSES } from '@joc/api-gateway';
// redux
import { connect, ConnectedProps } from 'react-redux';
import { deleteOpportunity, getAllOpposCounts, updateActiveStatus } from 'redux/opportunities-service/action';
import { setError } from 'redux/error-service/action';
// components
import PopupMain from 'components/Organization/Opportunities/OpportunityPopups/PopupMain';
import PopupUpdate from 'components/Organization/Opportunities/OpportunityPopups/PopupUpdate';
import PopupConfirmation from 'shared/components/PopupConfirmation';
import ButtonTrash from 'shared/components/Buttons/ButtonTrash';
import ButtonPencil from 'shared/components/Buttons/ButtonPencil';
// import ButtonShare from 'shared/components/Buttons/ButtonShare';
import SnackbarSuccess from 'shared/components/Snackbars/SnackbarSuccess';
import ButtonSuspending from 'shared/components/Buttons/ButtonSuspending';
// photos
import PlaySVG from 'assets/image/play.svg';
import PauseSVG from 'assets/image/pause.svg';
// styles
import styles from './OpportunityActionsCell.module.scss';
import defaultStyles from '../CellDefault.module.scss';
import { EditManualOppPopup } from '../../../../../components/Organization/Opportunities/ManualOpportunityForm/EditMannualOppoPopup/EditManualOppoPopup';
import { OPPORTUNITY_TYPES } from '@joc/api-gateway/lib/api-client';
import { SUPER_ADMIN_OPPORTUNITIES_QUERY_KEY } from 'components/Organization/Opportunities/SuperAdminOpportunitiesNew/hooks/useSuperAdminOpportunities';

type OpportunityActionsCellParentProps = {
	opportunityData: IOpportunityResponse;
};

const OpportunityActionsCell: FC<OpportunityActionsCellProps> = ({
	opportunityData,
	deleteOppo,
	changeActiveStatus,
	getCounts,
	setErrors,
}: OpportunityActionsCellProps) => {
	const queryClient = useQueryClient();
	const [isShowUpdatePopup, setIsShowUpdatePopup] = useState(false);
	const [isShowConfirmation, setIsShowConfirmation] = useState(false);
	const [isOpenSnackbar, setIsOpenSnackbar] = useState(false);

	const deleteConfirmClickHandler = async () => {
		try {
			await deleteOppo(opportunityData.id);
			await getCounts();
			queryClient.invalidateQueries({
				queryKey: [SUPER_ADMIN_OPPORTUNITIES_QUERY_KEY],
				exact: false,
			});
		} catch (error: any) {
			setErrors(error?.response?.message || error.message, error.code);
		} finally {
			setIsShowConfirmation(false);
		}
	};

	const editClickHandler = () => {
		setIsShowUpdatePopup(true);
	};
	const createClickHandler = () => {
		setIsShowUpdatePopup(true);
	};

	return (
		<div className={cx(styles.actions, defaultStyles.main)}>
			<div className={styles.actions__content}>
				<ButtonPencil
					clickHandler={
						opportunityData.status === OPPORTUNITY_STATUSES.CLOSED ? createClickHandler : editClickHandler
					}
				/>
				<ButtonTrash clickHandler={() => setIsShowConfirmation(true)} />
				{/* <ShareLinks
					customSvg={ShareSvg}
					customStyles={styles.norelative}
					customLink={`${process.env.REACT_APP_MAIN_URL_DEV}${urls.feedviewLink}/${opportunityData.id}`}
					isShowPopup={isShowPopup}
					setIsShowPopup={setIsShowPopup}
					setIsOpenSnackbar={setIsOpenSnackbar}
				/> */}
				{opportunityData.opportunityActiveStatus.status !== OPPORTUNITY_ACTIVE_STATUS.SUSPENDED ? (
					<ButtonSuspending
						clickHandler={() => {
							changeActiveStatus({
								opportunityId: `${opportunityData.id}`,
								status: OPPORTUNITY_ACTIVE_STATUS.SUSPENDED,
							});
						}}
						title="suspend opportunity"
						href={PauseSVG}
					/>
				) : (
					<ButtonSuspending
						clickHandler={() => {
							changeActiveStatus({
								opportunityId: `${opportunityData.id}`,
								status: OPPORTUNITY_ACTIVE_STATUS.ACTIVE,
							});
						}}
						title="suspend opportunity"
						href={PlaySVG}
					/>
				)}
			</div>
			{isShowUpdatePopup &&
				(opportunityData.opportunityType === OPPORTUNITY_TYPES.MANUAL ||
				opportunityData.opportunityType === OPPORTUNITY_TYPES.PUBLIC ? (
					<EditManualOppPopup opportunityData={opportunityData} setIsOpenPopup={setIsShowUpdatePopup} />
				) : (
					<PopupMain setIsShowPopup={setIsShowUpdatePopup}>
						<PopupUpdate
							setIsShowUpdateOpportunityPopup={setIsShowUpdatePopup}
							opportunityData={opportunityData}
						/>
					</PopupMain>
				))}
			{isShowConfirmation && (
				<PopupConfirmation
					confirmClickHandler={deleteConfirmClickHandler}
					cancelClickHandler={() => setIsShowConfirmation(false)}
					setIsShowPopup={setIsShowConfirmation}
				/>
			)}
			{isOpenSnackbar && (
				<SnackbarSuccess
					isOpenSnackbar={isOpenSnackbar}
					setIsOpenSnackbar={setIsOpenSnackbar}
					text={LinkCopiedSuccessfully}
				/>
			)}
		</div>
	);
};

const mapDispatchToProps = {
	deleteOppo: deleteOpportunity,
	changeActiveStatus: updateActiveStatus,
	setErrors: setError,
	getCounts: getAllOpposCounts,
};

const connector = connect(null, mapDispatchToProps);

type OpportunityActionsCellProps = ConnectedProps<typeof connector> & OpportunityActionsCellParentProps;

export default connector(OpportunityActionsCell);
